import { Component } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';

@Component({
    selector: 'mon-not-allowed',
    imports: [SharedModule],
    templateUrl: './not-allowed.component.html',
    styleUrl: './not-allowed.component.scss'
})
export class NotAllowedComponent {

}
